(function (window) {
    "use strict";

    DSV.template.listViewTemplate = {
        getTemplate: (mappedProperties, document, searchId, baseUrl) => {
            const {Id: documentId, LogicalOffset: documentOffset} = document;

            return `
            <li>
                <h3><a href="${baseUrl}?url=${mappedProperties.get('Uri')[0].Value}&documentId=${documentId}&documentOffset=${documentOffset}&searchId=${searchId}">${mappedProperties.get('Title')[0].ValueMarkup}</a></h3>
                <div>
                    ${mappedProperties.get('Content') && mappedProperties.get('Content')[0].ValueMarkup}
                </div>
                <a href="${baseUrl}?url=${mappedProperties.get('Uri')[0].Value}&documentId=${documentId}&documentOffset=${documentOffset}&searchId=${searchId}">${decodeURIComponent(mappedProperties.get('Uri')[0].Value)}</a>
            </li>
        `}
    };
})(window);